import { EMAIL_CREATION_FORM_FIELD_NAME_INSERT_REPLACE } from '../EmailCreationForm.constants'

import { TemplateConfirmationInsertReplaceOptionValue } from './TemplateConfirmationModal.enums'

export const INITIAL_VALUES = {
  [EMAIL_CREATION_FORM_FIELD_NAME_INSERT_REPLACE]:
    TemplateConfirmationInsertReplaceOptionValue.Insert,
}
